import * as React from 'react';
import * as moment from 'moment';
import request from '@/server/request';
import config from '@/server/config';
import Dialog from '@/pages/components/dialog';
import './scss/index.scss'
import * as utils from '@/server/utils';

export default class InquiryMessage extends React.Component < any, any > {
    constructor(props: any) {
        super(props);
        const backId = Number(utils.getQueryString('backId') || 0);
        const companyId = Number(utils.getQueryString('companyId') || '');
        const type = Number(utils.getQueryString('type') || '');
        this.state = {
            tabId: backId,
            companyId,
            backId,
            type, // 1 卖家  2 买家
            consultList: [], // 咨询列表
            buyerConsultList: [], // 买家商品咨询
            sampleList: [], // 索取样品数据
            commodityCollectList: [], // 商品收藏数据
            storeCollectList: [], // 商铺收藏数据
            crossList: [],
            page: 1, // 页码
            showAlert: false, // 显示留言弹层
            alertText: '', // 留言内容
            inquiryList: [], // 推送数据
            dotList: [],
            pushUnreadNum: 0,
            openCrossShop: false
        };
    }

    public loadBtn = true;

    componentDidMount() {
        const _THIS = this;
        if (this.state.type === 1) {
            this.changeTabId(this.state.tabId || 1);
            this.checkCrossShop()
        } else {
            this.changeTabId(this.state.tabId);
        }

        window.onscroll = function() {
            if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50 || document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
                if (!_THIS.loadBtn) {
                    return;
                }

                _THIS.setState({
                    page: _THIS.state.page + 1,
                }, () => {
                    if (_THIS.loadBtn) {
                        _THIS.tabBackFunction(_THIS.state.tabId)
                    }
                });
            }
        }
    }

    componentWillUnmount() {
        window.onscroll = null
    }

    render() {
        return (
            <div className="page-inquiryMessage">
				<ul className="top-nav">
					{
						this.state.type === 2 &&
						<li className="nav-column">
							<span className={`nav-text ${this.state.tabId === 0 ? 'active' : ''}`} onClick={() => this.changeTabId(0)}>
								商品咨询
								{
									this.state.dotList.indexOf(1) !== -1 ? <i className="dot" /> : ''
								}
							</span>
						</li>
					}
					<li className="nav-column">
						<span className={`nav-text ${this.state.tabId === 1 ? 'active' : ''}`} onClick={() => this.changeTabId(1)}>
							索取样品
						</span>
					</li>
					{
						this.state.type === 1 ?
							<li className="nav-column">
								<span className={`nav-text ${this.state.tabId === 2 ? 'active' : ''}`} onClick={() => this.changeTabId(2)}>
									推送记录
								{
										this.state.dotList.indexOf(3) !== -1 ? <i className="dot" /> : ''
									}
								</span>
							</li> : ''
					}
					{
						this.state.type === 1 ?
							<li className="nav-column">
								<span className={`nav-text ${this.state.tabId === 3 ? 'active' : ''}`} onClick={() => this.changeTabId(3)}>
									商品收藏记录
								{
										this.state.dotList.indexOf(4) !== -1 ? <i className="dot" /> : ''
									}
								</span>
							</li> : ''
					}
					{
						this.state.type === 1 ?
							<li className="nav-column">
								<span className={`nav-text ${this.state.tabId === 4 ? 'active' : ''}`} onClick={() => this.changeTabId(4)}>
									店铺收藏记录
								{
										this.state.dotList.indexOf(5) !== -1 ? <i className="dot" /> : ''
									}
								</span>
							</li> : ''
					}
					{
						this.state.type === 1 && this.state.openCrossShop ?
							<li className="nav-column">
								<span className={`nav-text ${this.state.tabId === 5 ? 'active' : ''}`} onClick={() => this.changeTabId(5)}>
									跨境求购留言
								</span>
							</li> : ''
					}


				</ul>
				<Dialog visiblity={this.state.showAlert}>
					<div className="alert active">
						<div className="content">
							<p className="title">留言</p>
							<p className="prompt">{this.state.alertText}</p>
						</div>
						<div className="bottom">
							<button className="btn" onClick={() => this.setState({ showAlert: false })}>关闭</button>
						</div>
					</div>
				</Dialog>

				<div className="tab-view">
					{
						this.state.type === 1 ? <div className={`tab-panel ${this.state.tabId === 0 ? 'active' : ''}`}>
							<div className="inquiry-list">
								{
									this.state.consultList.map((item: any, k: number) => {
										return (
											<div className="inquiry-card" key={k}>
												<ul className="info-list">
													<li className="info-row">
														<span className="label">产品名称</span>
														<span className="text line-clamp-1">{item.goods.goods_name}</span>
													</li>
													<li className="info-row">
														<span className="label">买家姓名</span>
														<span className="text line-clamp-1">{item.user_linkman}</span>
													</li>
													<li className="info-row">
														<span className="label">联系电话</span>
														<span className="text line-clamp-1">{item.user_tel}</span>
													</li>
													<li className="info-row">
														<span className="label">留言时间</span>
														<span className="text line-clamp-1">{item.created_at}</span>
													</li>
												</ul>
												<div className="buttom-text" onClick={() => this.setState({ showAlert: true, alertText: item.note })}>
													<span className="text">查看留言</span>
													<i className="icon"></i>
												</div>
											</div>
										)
									})
								}
							</div>
						</div>
							:
							<div className={`tab-panel ${this.state.tabId === 0 ? 'active' : ''}`}>
							<ul className="zxlist">
								{
									this.state.buyerConsultList.map((item: any) => {
										return (
											<li key={ item.enquiry_id } data-id={item.enquiry_id}>
												<p className="timelist">
													<span className="times1 fl">
														询价时间：{item.created_at ? item.created_at.substr(0, item.created_at.length - 3) : ''}
													</span>
													{
														item.follow_created_at ?
														<span className="times2 fr">
															报价时间：{item.follow_created_at.substr(0, item.follow_created_at.length - 3)}
														</span> : null
													}
												</p>
												<div className="goods">
													<div className="seegoods">
														<h2 className="fl"><span>{item.shop_name}</span></h2>
														<span className="fr" onClick={ () => this.viewGoodsDetail(item.shop_domain, item.goods_id) }>查看商品</span>
													</div>
													<dl className="xjsp">
														<a href="#" >
															<dt><img src={item.img_src} /></dt>
															<dd><h3>{item.goods_name}</h3><p>报价数量：{item.number}{item.unit_name}</p></dd>
														</a>
													</dl>
													<div className="hf">
														<img src={require('../../../assets/images/hf1.png')} />
														{
															item.status > 0 ? <div><p>报价价格：{item.offer}元 / {item.unit_name}</p><p>报价原因：{item.reason} </p></div> : <p>商家暂无回复</p>
														}
														<img src={require('../../../assets/images/hf3.png')} />
													</div>
												</div>
											</li>
										)
									})
								}
								</ul>
							</div>
					}
					{
						this.state.tabId === 0 && ((this.state.type === 1 && !this.state.consultList.length) || (this.state.type === 2 && !this.state.buyerConsultList.length)) ?
							<div className="upgrade">
								<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
							</div> : ''
					}
					<div className={`tab-panel ${this.state.tabId === 1 ? 'active' : ''}`}>
						<div className="inquiry-list">
							{
								this.state.sampleList.map((item: any, k: number) => {
										return (
											<div
												className="inquiry-card" key={k}
												onClick={() => this.state.type === 1 ? (item.sample_status === '1' &&  this.intercept(() => (this.props.history as any).push('/inquiry/details?id=' + item.offer_sample_id))) : this.intercept(() => (this.props.history as any).push('/inquiry/list?id=' + item.sample_id))
											}
											>
												<ul className="info-list">
													<li className="info-row">
														<span className="label">索样产品</span>
														<span className="text line-clamp-1">{item.goods_name}</span>
													</li>
													{
														this.state.type === 1 ?
														<li className="info-row">
															<span className="label">企业名称</span>
															{
																(item.sample_status === '0' || item.sample_status === '2') ? <span className="text line-clamp-1">***</span> : <span className="text line-clamp-1">{item.sample.user_company}</span>
															}
														</li> : null
													}
													<li className="info-row">
														<span className="label">收货人姓名</span>
														{
															this.state.type === 1 ? ((item.sample_status === '0' || item.sample_status === '2') ? <span className="text line-clamp-1">***</span> : <span className="text line-clamp-1">{item.sample.user_linkman}</span>) : <span className="text line-clamp-1">{item.user_linkman}</span>
														}
													</li>
													<li className="info-row">
														<span className="label">联系电话</span>
														{
															this.state.type === 1 ? ((item.sample_status === '0' || item.sample_status === '2') ? <span className="text line-clamp-1">***</span> : <span className="text line-clamp-1">{item.sample.user_tel}</span>) : <span className="text line-clamp-1">{item.user_tel}</span>
														}
													</li>
													<li className="info-row">
														<span className="label">状态</span>
														<span className="text line-clamp-1">{item.sample_status_name}</span>
													</li>
													{
														item.sample_status === '2' && <li className="info-row">
															<span className="label"></span>
															<span className="text line-clamp-1 font-blue">{item.status_no_pass}</span>
														</li>
													}
													<li className="info-row">
														<span className="label">留言时间</span>
														<span className="text line-clamp-1">{item.created_at}</span>
													</li>
												</ul>
												{
													(this.state.type === 1 && item.sample_status === '1') || this.state.type === 2 ? <div className="buttom-text">
													<span className="text">查看供样详情</span>
													<i className="icon"></i>
												</div> : null
												}
											</div>
										)
								})
							}
						</div>
						{
							!this.state.sampleList.length ?
								<div className="upgrade">
									<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
								</div> : ''

						}
					</div>

					<div className={`tab-panel ${this.state.tabId === 2 ? 'active' : ''}`}>
						<div className="inquiry-list">
							{
								this.state.pushUnreadNum > 0 ?
								<div className="cgtip"><p className="newTip">有{this.state.pushUnreadNum}条最新求购信息</p></div> : null
							}
							{
								this.state.inquiryList.map((item: any, k: number) => {
									return (
										<div
											className="inquiry-card"
											key={k}
											onClick={() => this.intercept(() => this.goDetails(item))}
										>
											{
												k < this.state.pushUnreadNum ?
												<b className="iconfontBG"><i className="icon-NEW iconfont"></i></b>
												: null
											}											
											<ul className="info-list">
												<li className="info-row">
													<span className="label">产品名称</span>
													<span className="text line-clamp-1">{item.stBreed}</span>
												</li>
												<li className="info-row">
													<span className="label">型号</span>
													<span className="text line-clamp-1">{item.stGrade}</span>
												</li>
												<li className="info-row">
													<span className="label">采购数量</span>
													<span className="text line-clamp-1">{item.stNumber} {item.stUnitString}</span>
												</li>
												<li className="info-row">
													<span className="label">买家信息</span>
													<span className="text"> {item.stateString === '过期' ? '过期无法查看' : `${item.stTrueName || ''} ${item.stMobile || ''} ${item.stCompany || ''}`} </span>
												</li>
												<li className="info-row">
													<span className="label">买家专员</span>
													<span className="text line-clamp-1">{item.buyerTrueName} {item.buyerMobile}</span>
												</li>
												<li className="info-row">
													<span className="label">状态</span>
													<span className="text line-clamp-1">{item.stateString}</span>
												</li>
												<li className="info-row">
													<span className="label">推送时间</span>
													<span className="text line-clamp-1">{moment(item.pushTime).format('YYYY-MM-DD HH:mm:ss')}</span>
												</li>
											</ul>
											<div className="buttom-text">
												<span className="text">查看详情</span>
												<i className="icon"></i>
											</div>
										</div>
									)
								})
							}
						</div>
						{
							!this.state.inquiryList.length ?
								<div className="upgrade">
									<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
								</div> : ''

						}
					</div>
					<div className={`tab-panel ${this.state.tabId === 3 ? 'active' : ''}`}>
						<div className="inquiry-list">
							{
								this.state.commodityCollectList.map((item: any, k: number) => {
									return (
										<div className="inquiry-card" key={k} onClick={() => this.intercept(() => (this.props.history as any).push({ pathname: '/user/collect', state: { id: item.goods_id } }))}>
											<ul className="info-list">
												<li className="info-row" onClick={(e: any) => {
													e.stopPropagation();
													window.location.href = item.shop_domain + 'offer?id=' + item.goods_id
												}}
													data-url={item.shop_domain + 'offer?id=' + item.goods_id}
												>
													<div className="product-row">
														<img src={item.goods_img} alt="" className="cover" />
														<div className="info">
															<p className="name">{item.goods_name}</p>
															<p className="price">￥{item.price_type === '4' ? item.proposed_price : item.show_origin_price}</p>
														</div>
														<span className="right-icon"></span>
													</div>
												</li>
												<li className="info-row">
													<span className="label">牌号</span>
													<span className="text line-clamp-1">{item.grade}</span>
												</li>
												<li className="info-row">
													<span className="label">生产商</span>
													<span className="text line-clamp-1">{item.manufacturer}</span>
												</li>
												<li className="info-row">
													<span className="label">收藏次数</span>
													<span className="text line-clamp-1">{item.goods_sum}</span>
												</li>
												<li className="info-row">
													<span className="label">收藏用户数</span>
													<span className="text line-clamp-1">{item.goods_sum1}</span>
												</li>
											</ul>
											<div className="buttom-text">
												<span className="text">查看收藏用户</span>
												<i className="icon"></i>
											</div>
										</div>
									)
								})
							}
						</div>
						{
							!this.state.commodityCollectList.length ?
								<div className="upgrade">
									<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
								</div> : ''

						}
					</div>
					<div className={`tab-panel ${this.state.tabId === 4 ? 'active' : ''}`}>
						<div className="inquiry-list">
							{
								this.state.storeCollectList.map((item: any, k: number) => {
									return (
										<div className="inquiry-card" key={k}>
											<ul className="info-list">
												<li className="info-row">
													<span className="label">收藏用户名</span>
													<span className="text line-clamp-1">{item.userName}</span>
												</li>
												<li className="info-row">
													<span className="label">公司名称</span>
													<span className="text line-clamp-1">{item.companyName}</span>
												</li>
												<li className="info-row">
													<span className="label">联系方式</span>
													<span className="text line-clamp-1">{item.mobilPhone}</span>
												</li>
												<li className="info-row">
													<span className="label">收藏时间</span>
													<span className="text line-clamp-1">{item.created_at}</span>
												</li>
											</ul>
										</div>
									)
								})
							}
						</div>
						{
							!this.state.storeCollectList.length ?
								<div className="upgrade">
									<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
								</div> : ''

						}
					</div>
					<div className={`tab-panel ${this.state.tabId === 5 ? 'active' : ''}`}>
            <div className="inquiry-list">
            	{
            		this.state.crossList.map((item: any, k: number) => {
            			return <div className="inquiry-card">
                <ul className="info-list">
                  <li className="info-row"><span className="label">产品信息</span><span className="text line-clamp-1">{item.produc_name}</span>
                  </li>
                  <li className="info-row"><span className="label">数量</span><span className="text line-clamp-1">{item.quantity}</span></li>
                  <li className="info-row"><span className="label">邮箱</span><span className="text line-clamp-1">{item.mailbox}</span>
                  </li>
                  <li className="info-row"><span className="label">姓名</span><span className="text line-clamp-1">{item.contact_name}</span></li>
                  <li className="info-row"><span className="label">地址</span><span className="text line-clamp-1">{item.address}</span></li>
                  <li className="info-row"><span className="label">企业名称</span><span className="text line-clamp-1">{item.company_name}</span>
                  </li>
                  <li className="info-row"><span className="label">电话号码</span><span className="text line-clamp-1">{item.telephone_no}</span>
                  </li>
                  <li className="info-row"><span className="label">信息</span><span className="text line-clamp-1">{item.message}</span>
                  </li>
                  <li className="info-row"><span className="label">录入时间</span><span className="text line-clamp-1">{item.created_at}</span>
                  </li>
                </ul>
              </div>
            		})
            	} 
            </div>
          </div>
				</div>

			</div>
        )
    }
    // 查询询盘消息
    private async getInquiryStatus() {
        let pushUnreadNum = 0;

        const r = await request({
            method: "get",
            url: `${config.MALLAPI}api/wshop/ask/user-ask`,
        });

        if (r.error_code === 0) {
            const list = this.state.type === 1 ? r.data.seller_list : r.data.buyer_list;

            const result = list.map((v: any) => {
                if (v.isshow === 1) {
                    return v.record_type
                }
            });

            r.data.seller_list.forEach((v: any) => {
                if (v.record_type === 3) {
                    pushUnreadNum = v.count;
                }
            });

            this.setState({
                pushUnreadNum,
                dotList: result
            })
        }
    }
    private goDetails(item: any) {
        (this.props.history as any).push(`/inquiry/purchaseDetails?rid=${item.id}&id=${item.stItemInfoId}`);
    }

    // tab切换
    private changeTabId(id: number) {
        let k = '';

        switch (id) {
            case 0:
                if (this.state.type === 1) {
                    k = 'consultList';
                } else {
                    k = 'buyerConsultList';
                }
                break;
            case 1:
                k = 'sampleList';
                break;
            case 2:
                k = 'inquiryList';
                break;
            case 3:
                k = 'commodityCollectList';
                break;
            case 4:
                k = 'storeCollectList';
                break;
            case 5:
                k = 'crossList';
                break;
            default:
                k = '';
        }

        this.setState({
            tabId: id,
            [k]: [],
            page: 1,
        }, () => {
            this.removtHotDot();
            this.tabBackFunction(id)
        });
    }

    private tabBackFunction(id: any) {
        this.loadBtn = true;

        switch (id) {
            case 0:
                this.getConsultData();
                break;
            case 1:
                this.getSampleData();
                break;
            case 2:
                this.getInquiryData();
                break;
            case 3:
                this.getCommodityCollectData();
            case 4:
                this.getStoreCollect();
            case 5:
                this.getCrossData();
            default:
        }
    }

    private async getCrossData() {
        if (!this.loadBtn) {
            return
        }

        this.loadBtn = false
        const r = await request({
            method: "post",
            url: `${config.MALLAPI}api/multi/default/list`,
            data: {
                page: this.state.page
            }
        })

        if (r.error_code === 0) {
            if (this.state.page >= r.data.page_count) {
                this.loadBtn = false;
            } else {
                this.loadBtn = true;
            }

            this.setState({
                crossList: this.state.crossList.concat(r.data.model)
            })
        }
    }

    // 取消红点
    private async removtHotDot() {
        let id: any = '';
        const seller = {
            1: 10,
            2: 3,
            3: 4,
            4: 5
        };
        const buyer = {
            0: 1,
            1: 10
        };
        if (this.state.type === 1) {
            id = seller[this.state.tabId];
        } else {
            id = buyer[this.state.tabId];
        }

        const r = await request({
            method: "post",
            url: `${config.MALLAPI}api/wshop/ask/remove-ask`,
            data: {
                type: this.state.type,
                recordType: id,
            }
        })

        if (r.error_code === 0) {
            this.getInquiryStatus();
            return;
        }
    }

    // 商品咨询数据
    private async getConsultData() {
        if (!this.loadBtn) {
            return;
        }

        this.loadBtn = false;

        let url = `${config.MALLAPI}api/wshop/note/index?companyId=${this.state.companyId}&page=${this.state.page}`;
        if (this.state.type === 2) {
            url = `${config.MALLAPI}api/wshop/enquiry/enquiry-list?page=${this.state.page}`;
        }

        const r = await request({
            method: "get",
            url
        })

        if (r.error_code === 0) {
            if (this.state.page >= r.data.page_count) {
                this.loadBtn = false;
            } else {
                this.loadBtn = true;
            }

            this.setState(this.state.type === 1 ? {
                consultList: this.state.consultList.concat(r.data.model),
            } : {
                buyerConsultList: this.state.buyerConsultList.concat(r.data.model)
            })
        }
    }

    // 索取样品数据
    private async getSampleData(callback ? : any) {
        if (!this.loadBtn) {
            return;
        }

        this.loadBtn = false;

        let apiUrl = this.state.type === 1 ? `${config.MALLAPI}api/wshop/sample/offer-list?companyId=${this.state.companyId}&page=${this.state.page}` : `${config.MALLAPI}api/wshop/sample/book-list?type=${this.state.type}&page=${this.state.page}`;

        const r = await request({
            method: "get",
            url: apiUrl,
        });

        if (r.error_code === 0) {
            if (this.state.page >= r.data.page_count) {
                this.loadBtn = false;
            } else {
                this.loadBtn = true;
            }

            this.setState({
                sampleList: this.state.sampleList.concat(this.state.type === 1 ? r.data.data : r.data.model),
            }, () => {
                callback ? callback() : ''
            })
        }
    }
    // 推送数据
    private async getInquiryData() {
        if (!this.loadBtn) {
            return;
        }

        this.loadBtn = false;

        const r = await request({
            method: "get",
            url: `${config.API}api/member/st/push/wiseShop/list?pageNum=${this.state.page}`,
        })

        if (r.code === 1) {
            if (this.state.page >= r.obj.pages) {
                this.loadBtn = false;
            } else {
                this.loadBtn = true;
            }

            this.setState({
                inquiryList: this.state.inquiryList.concat(r.obj.list)
            })
        }
    }

    // 商品收藏数据
    private async getCommodityCollectData() {
        if (!this.loadBtn) {
            return;
        }

        this.loadBtn = false;

        const r = await request({
            method: "get",
            url: `${config.MALLAPI}api/wshop/collection/goods-collection?page=${this.state.page}`,
        })

        if (r.error_code === 0) {
            if (this.state.page >= r.data.page_count) {
                this.loadBtn = false;
            } else {
                this.loadBtn = true;
            }

            this.setState({
                commodityCollectList: this.state.commodityCollectList.concat(r.data.model),
            })
        }
    }

    // 商铺收藏数据
    private async getStoreCollect() {
        if (!this.loadBtn) {
            return;
        }

        this.loadBtn = false;

        const r = await request({
            method: "get",
            url: `${config.MALLAPI}api/wshop/collection/shop-collection?page=${this.state.page}`,
        })

        if (r.error_code === 0) {
            if (this.state.page >= r.data.page_count) {
                this.loadBtn = false;
            } else {
                this.loadBtn = true;
            }

            this.setState({
                storeCollectList: this.state.storeCollectList.concat(r.data.model),
            })
        }
    }

    /**
     * 跳转商品详情
     * @param shopDomain 店铺域名
     * @param goodsId 商品id
     */
    private viewGoodsDetail(shopDomain: string, goodsId: number) {
        window.location.href = `${shopDomain}offer/?id=${goodsId}`
    }

    private intercept(callback: any) {
        this.removtHotDot();

        callback && callback();
    }

    // 查询是否开通跨境店铺
    private async checkCrossShop() {
        const r = await request({
            method: "get",
            url: `${config.MALLAPI}api/wshop/default/cross-border?cid=${this.state.companyId}`,
        })

        if (r.error_code === 0) {
            this.setState({
                openCrossShop: r.data === "2"
            })
        }
    }
}